import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styles from "./style.module.css";

const PhoneNumberInput = (props) => {
  const { name, value, required, placeholder, id, onChange } = props;

  return (
    <div className={styles.phone_number_input}>
      <PhoneInput
        inputProps={{
          id: id,
          name: name,
          required: required,
          placeholder: placeholder,
        }}
        country={"us"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default PhoneNumberInput;
